import { orchestrator } from "satcheljs";
import SmartScheduleGenerationPollingService from "sh-services/lib/SmartScheduleGenerationPollingService";
import { cancelSmartScheduleGenerationJob, ICancelSmartScheduleGenerationJobParams } from "../actions/cancelSmartScheduleGenerationJob";
import { smartSchedulePollingState } from "../store/smartSchedulePollingState";
import setGlobalMessage from "sh-application/actions/setGlobalMessage";
import { appViewState } from "sh-application/store";

/**
 * Orchestrator: onCancelSmartScheduleGenerationJob
 * Performs cancellation via the polling service, then clears the global message bar.
 * Fire-and-forget semantics: component dispatches action and immediately dismisses dialog; side-effects handled here.
 */
export const onCancelSmartScheduleGenerationJob = orchestrator(
    cancelSmartScheduleGenerationJob,
    async (params: ICancelSmartScheduleGenerationJobParams) => {
        const { teamId, tagId, jobId } = params || {};
        // Derive missing identifiers from polling snapshot
        const polling = smartSchedulePollingState();
        const statusEntity = polling.statusEntity;
        const derivedTagId = tagId || statusEntity?.tagId;
        const derivedJobId = jobId || polling.jobId || statusEntity?.jobId;
        try {
            await SmartScheduleGenerationPollingService.cancelActiveJob(teamId, derivedTagId, derivedJobId);
        } catch (e) {
            // Swallow to avoid bubbling into React event system (was causing cross-origin opaque error).
        } finally {
            setGlobalMessage(appViewState().globalMessageViewState);
        }
    }
);

export default onCancelSmartScheduleGenerationJob;